import { useQuery } from '@tanstack/react-query';
import { useAPIClient } from '@/hooks/useAPIClient';

export interface IngestionTask {
  task_id: string;
  status: 'pending' | 'running' | 'completed' | 'failed' | 'cancelled' | 'cancelling';
  progress: number;
  current_file: string | null;
  files_processed: number;
  files_total: number;
  processing_status: string;
  error?: string;
  started_at: string;
  completed_at?: string;
}

/**
 * Hook to poll ingestion task status
 * Automatically polls every 1 second while task is active
 * Stops polling when task completes, fails, or is cancelled
 */
export const useIngestionProgress = (taskId: string | null) => {
  const apiClient = useAPIClient();

  return useQuery<IngestionTask>({
    queryKey: ['ingestion-task', taskId],
    queryFn: async () => {
      if (!taskId) throw new Error('No task ID');
      return apiClient.documents.getTaskStatus(taskId);
    },
    enabled: !!taskId,
    refetchInterval: (data) => {
      // Poll every 1 second while task is active
      // Stop polling when task completes/fails/cancels
      const activeStatuses = ['pending', 'running', 'cancelling'];
      return data && activeStatuses.includes(data.status) ? 1000 : false;
    },
    retry: false,
  });
};
